/**
 * Generates the initials from a given name.
 *
 * @param name - The full name from which to generate initials.
 * @returns The initials of the given name. If the name contains multiple words,
 *          the initials of the first two words are returned.
 *
 * @example
 * ```
 * getInitials("John Doe"); // "JD"
 * getInitials("Jane Mary Doe"); // "JM"
 * getInitials("Single"); // "S"
 * ```
 */
export const getAvatarInitials = (name: string): string => {
  const initials = name
    .split(" ")
    .map(word => word[0])
    .slice(0, 2)
    .join("");
  return initials;
};

/**
 * Generates a color based on a given string.
 *
 * @param string - The string from which to generate a color.
 * @returns A color in hexadecimal format.
 *
 * @example
 * ```
 * getAvatarColor("John Doe"); // "#f5a623"
 * getAvatarColor("Jane Mary Doe"); // "#f5a623"
 * getAvatarColor("Single"); // "#f5a623"
 * ```
 */
export const getAvatarColor = (string: string) => {
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
};

